import React, { useEffect, useState } from "react";
import { Button, Breadcrumb, Card, CardBody, CardHeader, Col, Container, Form, Row, Stack } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Select from 'react-select';

import PubSub from "pubsub-js";
import moment from "moment";

import { regExPattern } from "../../utils/regExPattern";
import { titles } from "../../constants/CONSTANT";
import { validationMessages } from "../../utils/messages";
import { ROUTES } from "../../constants/webRouting";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import CityState from "../../constants/CityState.json";
import { getUserDetails } from "../../utils/helper";
import { handleUppercaseChange } from "../common/UpperCaseMethod";
// Define initial errors i.e. required field and their message
const initialErrors = {
  name: { message: validationMessages.name.required },
};
const userInfo = getUserDetails();

const initialValues = {
  city: "Jaipur",
};

const states = [...(new Set(CityState.map((item) => item.state)))];

const AccountEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // account state
  const [account, setAccount] = useState(location.state ? location.state : initialValues);

  //errors state
  const [errors, setErrors] = useState(!location.state ? initialErrors : {});
  //useEffect(() => { console.log('errors', errors) }, [errors]);

  // validation state
  const [validated, setValidated] = useState(false);


  // Handle City & state values
  // const [states, setStates] = useState([...(new Set(CityState.map((item) => item.state)))]);
  const [cities, setCities] = useState(null);

  // If state value changed set the cities according to state
  useEffect(() => {
    setCities([...(new Set(CityState.filter((item) => item.state == account?.state).map((item) => item.name)))]);
  }, [account?.state]);

// onChange Handler
  const handleChange = (e) => {
    const { name, value } = e.target;
 if (name == "name") {
      if (value == "") {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.name.required } }));
      } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.name.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "email") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.email.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name === "phone") {
      if (value === "") {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.phone.required } }));
      } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.phone.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "pincode") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.pinCode.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "country") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.country.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "state") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.state.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    // else if (name == "website") {
    //   if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
    //     setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.website.invalid } }));
    //   } else {
    //     setErrors((prev) => {
    //       delete prev[name];
    //       return { ...prev };
    //     });
    //   }
    // }

    setValidated(true);
    setAccount((prev) => ({ ...prev, [name]: value }));
  };

  // field validators
  const checkRequiredFields = () => {
    let isError = false;

    if (account?.name) {
      if (account?.name == "") {
        setErrors((prev) => ({ ...prev, 'name': { message: "Please provide a Name." } }));
        isError = true;
      } else if (regExPattern?.name && (!RegExp(regExPattern.name).test(account?.name))) {
        setErrors((prev) => ({ ...prev, 'name': { message: "Please provide Valid Name." } }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev['name'];
          return { ...prev };
        });
      }
    }
    // if (account?.website) {
    //   if (account?.website == "") {
    //     setErrors((prev) => ({ ...prev, 'website': { message: "Please provide a Website." } }));
    //     isError = true;
    //   } else if (regExPattern?.name && (!RegExp(regExPattern.name).test(account?.website))) {
    //     setErrors((prev) => ({ ...prev, 'website': { message: "Please provide Valid Website." } }));
    //     isError = true;
    //   } else {
    //     setErrors((prev) => {
    //       delete prev['website'];
    //       return { ...prev };
    //     });
    //   }
    // }

    if (account?.email) {
      if (account?.email != "" && regExPattern?.email && (!RegExp(regExPattern.email).test(account.email))) {
        setErrors((prev) => ({ ...prev, 'email': { message: "Please provide Valid Email." } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['email'];
          return { ...prev };
        });
      }
    }

    if (account?.pincode) {
      if (account?.pincode != "" && regExPattern?.pinCode && (!RegExp(regExPattern.pinCode).test(account.pincode))) {
        setErrors((prev) => ({ ...prev, 'pincode': { message: "Please provide valid pincode." } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['pincode'];
          return { ...prev };
        });
      }
    }

    if (account?.country) {
      if (account?.country != "" && regExPattern?.name && (!RegExp(regExPattern.name).test(account.country))) {
        setErrors((prev) => ({ ...prev, 'reference': { message: "Please provide valid country name." } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['country'];
          return { ...prev };
        });
      }
    }
    if (account?.phone) {
        if (account?.phone == "") {
        setErrors((prev) => ({ ...prev, 'phone': { message: "Please provide phone." } }));
        isError = true;
        } else if (regExPattern?.phone && (!RegExp(regExPattern.phone).test(account.phone))) {
        setErrors((prev) => ({ ...prev, 'phone': { message: "Please provide Valid phone." } }));
        isError = true;
        } else {
        setErrors((prev) => {
            delete prev['phone'];
            return { ...prev };
        });
        }
    }



    // handle errors for required fields
    if (!account?.name) {
      setErrors((prev) => ({ ...prev, 'name': { message: validationMessages.name.required } }));
      isError = true;
    }
    // if (!account?.lastname) {
    //   setErrors((prev) => ({ ...prev, 'lastname': { message: validationMessages.lastName.required } }));
    //   isError = true;
    // }
    // if (!account?.phone) {
    //   setErrors((prev) => ({ ...prev, 'phone': { message: validationMessages.phone.required } }));
    //   isError = true;
    // }
    // if (!account?.title) {
    //   setErrors((prev) => ({ ...prev, 'title': { message: validationMessages.title.required } }));
    //   isError = true;
    // }

    return isError;
  };

  // onSubmit handler 
  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("handleSubmit Call")

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    console.log("checkRequiredFields Call")
    if (Object?.keys(errors)?.length != 0) {
      console.log("Object?.keys(errors)?.length",Object?.keys(errors)?.length);
      setValidated(true);
      return;
    }

    console.log("Object?.key Call")

    // //========= Logic to perform Create or Edit ======
    if (account.id) {
      // console.log('Updated');
      const result = await fuziElevatorsApi.saveAccount(account);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Update",
          message: "Record updated successfully",
        });
        navigate(`${ROUTES.ACCOUNT.LIST}/${account?.id}`, { state: account });
      } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Update Error', message: result?.errors });
      }
    } else {
      // console.log('Created');
      const result = await fuziElevatorsApi.createAccount(account);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record created",
          message: "Record created successfully",
        });
        navigate(`${ROUTES.ACCOUNT.LIST}/${result.id}`, { state: result.data });
      } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Save Error', message: result?.errors });
      }
    }
  };
 
  const handleCancel = () => {
    if (account.id) {
      navigate(`${ROUTES.ACCOUNT.LIST}/${account.id}`, { state: account });
    } else {
      navigate(ROUTES.ACCOUNT.LIST);
    }
  };
 
  return (
    <Container className="pb-5">
      <Row>
        <Col md={12}  className="sticky-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>Home</Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.ACCOUNT.LIST)} >Accounts</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col md={12}>
          <Form
            className=""
            onSubmit={() => handleSubmit}
            noValidate
            validated={validated}
          >
            <Card className="shadow">
              <CardHeader className="bg-custom text-white sticky-card-header">
                <Row className="w-100"  >
                  <Col lg={6} className="" >
                    <div className="d-flex align-items-center h-100 gap-3" >
                      {account?.id ? (
                        <h5 className="m-0">Edit Make {account?.name || ""}</h5>
                      ) : (
                        <h5 className="m-0">Create Make</h5>
                      )}
                    </div>
                  </Col>
                  <Col lg={6} className="p-0" >
                    <Stack direction="horizontal" className="float-end" gap={2}>
                      <Button
                        size="sm"
                        className="btn-save"
                        onClick={handleSubmit}>
                        Save
                      </Button>
                      <Button
                        size="sm"
                        className="btn-delete"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </Stack>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="">

                <Row lg={12} className="view-form ">

                  <Col lg={6} className="">
                      <Form.Group className="w-100" >
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicFirstName"
                        >
                        Name
                        </Form.Label>
                        <Form.Control
                          required
                          pattern={regExPattern.name}
                          type="text"
                          name="name"
                          placeholder="Enter Name"
                          value={account?.name || ""}
                          // onChange={handleChange}
                          onChange={(e) => handleUppercaseChange(e, handleChange)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.name?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                  </Col>

                  {/* Added thid type field by imran khan  */}
                  <Col lg={6}>
                    <Form.Group className="w-100">
                      <Form.Label 
                        className="form-view-label"
                        htmlFor={"formBasicMotorMake"}
                      >
                        Type
                      </Form.Label>

                      <Form.Control
                        as="select"
                        name="type"
                        value={account?.type || ""}
                        onChange={handleChange}
                      >
                        <option value="">--select type--</option>
                        <option value="Motor Make">Motor Make</option>
                        <option value="Door Make">Door Make</option>
                        <option value="Control Panel Make">Control Panel Make</option>
                        <option value="Company Make">Company Make</option>
                      </Form.Control>

                      <Form.Control.Feedback type="invalid">
                        {errors?.type?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  
                  <Col lg={6} className="">
                      <Form.Group className="w-100" >
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicFirstName"
                        >
                        Website
                        </Form.Label>
                        <Form.Control
                         // pattern={regExPattern.name}
                          type="text"
                          name="website"
                          placeholder="Enter Website"
                          value={account?.website || ""}
                          onChange={handleChange}
                        />
                        {/* <Form.Control.Feedback type="invalid">
                          {errors?.website?.message}
                        </Form.Control.Feedback> */}
                      </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicEmail"
                      >
                        Email
                      </Form.Label>
                      <Form.Control
                        pattern={regExPattern.email}
                        type="email"
                        name="email"
                        placeholder="Enter Email"
                        value={account?.email || ""}
                        onChange={handleChange}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors?.email?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group  >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPhone"
                      >
                        Phone
                      </Form.Label>
                      <Form.Control
                        //required
                        type="text"
                        name="phone"
                        placeholder="Enter Phone"
                        value={account?.phone || ""}
                        onChange={handleChange}
                        maxLength={10}
                        pattern={regExPattern.phone}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.phone?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicState"
                      >
                        State
                      </Form.Label>

                      <Select
                        placeholder="Select your state"
                        options={states?.map((state) => ({ 'value': state, 'label': state }))}
                        onChange={(e) => {
                          setAccount((prev) => ({ ...prev, city: "" }));
                          handleChange({ target: { name: "state", 'value': e.value } });
                        }}
                        value={account?.state ? { value: account?.state || "", label: account?.state || "" } : ""}
                      ></Select>
                      <Form.Control.Feedback type="invalid">
                        {errors?.state?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicCity"
                      >
                        City
                      </Form.Label>
                      {/* <Select
                        placeholder="Select your city"
                        // className={`${contact?.city ? 'custom-react-select-valid': 'custom-react-select-invalid' }`}
                        className={'custom-react-select'}
                        options={cities?.map((city) => ({ 'value': city, 'label': city }))}
                        onChange={(e) => {
                          handleChange({ target: { name: "city", 'value': e.value } });
                        }}
                        value={account?.city ? { value: account?.city || "", label: account?.city || "" } : ""}
                      /> */}
                      <Form.Control
                        type="text"
                        name="city"
                        placeholder="Enter City"
                        value={account?.city || ""}
                        // onChange={handleChange}
                        onChange={(e) => handleUppercaseChange(e, handleChange)}
                        pattern={regExPattern.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.city?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* <Col lg={6}>
                    <Form.Group  >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicCountry"
                      >
                        City
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        placeholder="Enter City"
                        value={account?.city || ""}
                        onChange={handleChange}
                        pattern={regExPattern.name}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors?.country?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group  >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicCountry"
                      >
                        State
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="state"
                        placeholder="Enter State"
                        value={account?.state || ""}
                        onChange={handleChange}
                        pattern={regExPattern.name}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors?.state?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}
                  {/* <Col lg={6}>
                    <Form.Group >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicState"
                      >
                        State
                      </Form.Label>

                      <Select
                        placeholder="Select your state"
                        options={states?.map((state) => ({ 'value': state, 'label': state }))}
                        onChange={(e) => {
                          setAccount((prev) => ({ ...prev, city: "" }));
                          handleChange({ target: { name: "state", 'value': e.value } });
                        }}
                        value={account?.state ? { value: account?.state || "", label: account?.state || "" } : ""}
                      ></Select>
                      <Form.Control.Feedback type="invalid">
                        {errors?.state?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}

                  <Col lg={6} className="">
                    <div className="d-flex gap-4">
                      <Form.Group className="w-100" >
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicFirstName"
                        >
                          Street
                        </Form.Label>
                        <Form.Control
                          // pattern={regExPattern.name}
                          type="text"
                          name="street"
                          placeholder="Enter Street"
                          value={account?.street || ""}
                          // onChange={handleChange}
                          onChange={(e) => handleUppercaseChange(e, handleChange)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.street?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <Form.Group >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPin"
                      >
                        Pincode
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="pincode"
                        placeholder="Enter PinCode"
                        value={account?.pincode || ""}
                        onChange={handleChange}
                        maxLength={6}
                        pattern={regExPattern.pinCode}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors?.pincode?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group  >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicCountry"
                      >
                        Country
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="country"
                        placeholder="Enter Country"
                        value={account?.country || ""}
                        // onChange={handleChange}
                        onChange={(e) => handleUppercaseChange(e, handleChange)}
                        pattern={regExPattern.name}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors?.country?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Col>
      </Row >

    </Container >

  );
};

export default AccountEdit;